(function processModuleDefinition() {
    'use strict';

    angular.module('Process', ['ui.router', 'Config', 'Entities', 'CustomControls', 'FileDownloader', 'ui.select', 'ui.selectExtend', 'TranslatedPaginator'])
        .config([
            'configProvider', '$stateProvider',
            function processConfig(config, $stateProvider) {
                $stateProvider.state('process-history', {
                    url: '/Process/History/{id}',
                    params: { goToDetail: undefined },
                    templateUrl: config.resourceUrl('/views/process/process-history.html'),
                    controller: 'ProcessHistoryController',
                    authorize: true
                });
            }
        ]);
})();
